import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  BrowserModule,
  HammerGestureConfig,
  HammerModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { NgModule, Injectable, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IsLoadingPipeModule } from './shared/is-loading/is-loading.pipe.module';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { ErrorInterceptor } from './shared/api-ux/error.interceptor';

import * as Hammer from 'hammerjs';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CommonModule } from '@angular/common';
import { SafePipeModule } from './shared/safe-pipe/safe-pipe.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatomoModule } from 'ngx-matomo';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { environment } from 'src/environments/environment';
registerLocaleData(localeFr, 'fr');

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    pinch: { enable: false },
    rotate: { enable: false },
    swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OuiLoadingModule,
    IsLoadingPipeModule,
    AppRoutingModule,
    HammerModule,
    SafePipeModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      registrationStrategy: 'registerImmediately',
    }),
    // MatomoModule,
    MatSnackBarModule,

    MatomoModule.forRoot({
      scriptUrl: environment.matomo.url + 'matomo.js',
      trackers: [
        {
          trackerUrl: environment.matomo.url + 'matomo.php',
          siteId: environment.matomo.siteId
        }
      ],
      routeTracking: {
        enable: true
      }
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'EUR',
    },
    { provide: LOCALE_ID, useValue: 'fr' }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
